import { Buffer } from 'buffer';

const BASE_URL = process.env.REACT_APP_REWARD_CLAIMING_API;
let NETWORK_NAME = process.env.REACT_APP_GENESIS_NETWORK;
if (NETWORK_NAME === "bsc+mainnet") NETWORK_NAME = "bsc";   // reward api is using bsc
const REWARD_MERKLE_TREE_LAYER_URL = process.env.REACT_APP_REWARD_MERKLE_TREE_LAYER_URL;
const NODE_BYTES_LENGTH = 32;

export async function getRewardDetails(address, account) {
    const url = `${BASE_URL}/claimable/${NETWORK_NAME}/${address}/${account}`;
    const res = await fetch(url);

    if (res.status == "200") {
        return await res.json();
    } else if (res.status == "404") {
        return null;
    }

    return null;
}

export async function getPayoutClaimSignature(address, account) {
    const url = `${BASE_URL}/signature/${NETWORK_NAME}/${address}/${account}`
    const res = await fetch(url);
    return await res.json();
}

export async function updateClaimStatus(address, account) {
    const claimed = `${BASE_URL}/claimed/${NETWORK_NAME}/${address}/${account}`
    return await fetch(claimed, { method: "PUT" });
}

export async function getProofByIndex(merkleRoot, index, layer) {
    const min = index * NODE_BYTES_LENGTH;
    const max = min + NODE_BYTES_LENGTH - 1;
    const res = await fetch(
        `${REWARD_MERKLE_TREE_LAYER_URL}/${merkleRoot.toLowerCase()}/levels/${layer}`,
        { headers: { 'range': `bytes=${min}-${max}` } }
    )

    const buffer = Buffer.from(await res.arrayBuffer());
    return `0x${buffer.toString('hex')}`;
}